export const DAY_SIZE = 36;
export const DAY_MARGIN = 2;
export const DIALOG_WIDTH = 320;
export const MAX_CALENDAR_HEIGHT = 280;
export const VIEW_HEIGHT = 334;
export const DIGITAL_CLOCK_VIEW_HEIGHT = 232;
export const MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;